import { useState } from 'react'
import AdminUsers   from './AdminUsers'
import AdminOrders  from './AdminOrders'
import AdminProducts from './AdminProducts'
import AdminStats from './AdminStats'
import AdminProductGroups  from './AdminProductGroups'
import AdminInbox  from './AdminInbox'
import AdminAddons from './AdminAddons' 

const tabs = ['Brukere', 'Ordrer', 'Produkter', 'Relasjoner', 'Grupper', 'Stats', 'Inbox']

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('Brukere')

  const renderContent = () => {
    switch (activeTab) {
      case 'Brukere':   return <AdminUsers />
      case 'Ordrer':    return <AdminOrders />
      case 'Produkter': return <AdminProducts />
      case 'Relasjoner':  return <AdminAddons /> 
      case 'Grupper':   return <AdminProductGroups />
      case 'Stats':   return <AdminStats />
      case 'Inbox':   return <AdminInbox />
      default:          return null
    }
  }

  return (
    // 1) Full-bredde wrapper for bakgrunn/padding
    <div className="w-full bg-gray-50 min-h-screen">
      {/* 2) Her styrer vi min/max-bredde */}
      <div
        className="px-6 py-8"
        style={{
          width: '80vw',       // minst 80% av viewport
          maxWidth: '90vw'     // maksimalt 90% av viewport
        }}
      >
        <h1 className="text-3xl font-bold text-[#000099] mb-6">
          Admin Dashboard
        </h1>

        {/* Tabs */}
        <div className="flex space-x-4 border-b pb-2 mb-6">
          {tabs.map(tab => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 rounded-t font-semibold ${
                activeTab === tab
                  ? 'bg-[#000099] text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Innhold */}
        <div className="bg-white shadow rounded-lg p-6 min-h-[600px] w-full">
          {renderContent()}
        </div>
      </div>
    </div>
  )
}
